import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'

import styles from './style.module.scss'
import nodataArt from '@assets/images/no-data.svg'
import nodataArtDark from '@assets/images/no-data-dark.svg'
import GlobalEventsContext from '@shared/components/global-events/GlobalEventsContext'

const MyImage = dynamic(() => import('@shared/components/myImage'))

const NoData = (props) => {
  const { stateGlobalEvents } = useContext(GlobalEventsContext)
  return (
    <div className={`${styles.NoData} my-2 mt-md-5 mb-md-3 text-center`}>
      <div className={`${styles.artwork} mx-auto mb-2`}>
        {
          stateGlobalEvents?.darkModeEna === 'dark' ? <MyImage src={props.img ? props?.img : nodataArtDark} alt="user" layout="responsive" /> : <MyImage src={props.img ? props?.img : nodataArt} alt="user" layout="responsive" />
        }
      </div>
      <h3 className={`${styles.two_line_ellipsis}`}>{props?.title || 'No Data Found'}</h3>
    </div>
  )
}
NoData.propTypes = {
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]),
  img: PropTypes.any
}

export default NoData
